import { Component, ComponentFactoryResolver, ViewChild, ViewContainerRef } from '@angular/core';
import { componentHolderService } from '../../providers/component-holder.service/component-holder.service';
import { DataServiceProvider } from '../../providers/data-service/data-service';

/**
 * Generated class for the MainComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'main-component',
  templateUrl: 'main-component.html'
})
export class MainComponent {
  @ViewChild('mainComponentHolder', { read: ViewContainerRef }) mainComponentHolder: ViewContainerRef;

  components: any;
  componentRef: any;
  constructor(public dataService: DataServiceProvider, public componentService: componentHolderService, private componentFactoryResolver: ComponentFactoryResolver) {
  }
  ngOnInit() {
    let component;
    this.components = this.componentService.getComponents();
    this.dataService.broadcastInfo({ src: 'app-component', event: 'GETAPPCOMPONENTS', status: true, params: this.components});
    component = this.getComponent('ComponentHolderComponent');
    if (component) {
      if (this.mainComponentHolder != undefined) {
        this.mainComponentHolder.clear();
      }
      let componentFactory = this.componentFactoryResolver.resolveComponentFactory(component['comp']);
      this.componentRef = this.mainComponentHolder.createComponent(componentFactory);
    }
  }
  getComponent(name) {
    for (let i = 0; i < this.components.length; i++) {
      let item = this.components[i];
      if (item.compName === name) {
     
        return item;
      }
    };
    return null;
  }

}



// WEBPACK FOOTER //
// ./src/components/main-component/main-component.ts